export default "__VITE_ASSET__f32c706b__"